import api from '../../plugins/api';

const getMenuItemCount = (params) => {
  return api.get('/api/crm/sidebar/getMenuItemCount', params);
};

export default getMenuItemCount;
